import Layout from '@/layout'

const accessLogRouter = {
  path: '/accesslog',
  component: Layout,
  name: 'accesslog',
  meta: {
    title: '系统日志',
    icon: 'el-icon-s-management',
    roles: ['root'],
    allowedUsers: ['solargard', 'admin'] // 只允许solargard用户访问
  },
  children: [
    {
      path: 'table',
      name: 'AccessLogTable',
      component: () => import('@/views/access_log/table'),
      meta: {
        title: '系统日志',
        icon: 'el-icon-s-management',
        roles: ['root'],
        allowedUsers: ['solargard', 'admin'], // 只允许solargard用户访问
        noCache: false
      }
    }
  ]
}

export default accessLogRouter
